export function defineValue(property: string | number): number {
	const prop = property.toString().trim();

	if (prop.indexOf("calc") === -1) {
		return parseInt(prop.split(/\D+/g)[0], null);
	}
}

export function defineUnit(property: string | number) {
	const prop = property.toString().trim();

	if (prop.indexOf("calc") === -1) {
		return prop.slice(prop.split(/\D+/g)[0].length);
	}
}